import React from 'react';
import CategoryPage from '../../categories/CategoryPage';

function Anexo21Y22RMF2026EvidenciasFotograficas() {
  return <CategoryPage category="anexo21Y22Rmf2026EvidenciasFotograficas" pageTitle="Evidencias Fotograficas 2026" />;
}

export default Anexo21Y22RMF2026EvidenciasFotograficas;
